// Charge la base commune
import './common.js'

// Contact Form
async function getCForm ($f, initializeEstimate = false) {
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
    if (initializeEstimate) { $(document).trigger('startEstimate') }
  })
}

// Masonry
async function getMasonry () {
  import(/* webpackChunkName: "masonry" */ './js/components/masonry.js').then(() => {
    Waypoint.refreshAll()
  })
}

// Gallery
async function getPhotoswipe () {
  import(/* webpackChunkName: "photoswipe" */ './js/components/photoswipe.js').then(() => {
    Waypoint.refreshAll()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // formulaire de contact
  const $c = $('form[name="cForm"]')
  $c.waypoint(function () {
    $c.load()
    getCForm($c)
    this.destroy()
  }, {
    offset: '100%'
  })

  $('#estimate').on('click', function () {
    $c.load()
    getCForm($c, true)
  })

  // gestion du masonry
  const $m = $('.grid')
  if ($m.length) {
    $m.waypoint(function () {
      getMasonry()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des galeries
  const $g = $('.gallery')
  if ($g.length) {
    $g.waypoint(function () {
      getPhotoswipe()
      this.destroy()
    }, {
      offset: '100%'
    })
  }
})
